(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        this._ro = null;
        this._mo = null;
    }

    connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
    this.getAttribute('data-sticky-type') === 'always' ||
    this.getAttribute('data-sticky-type') === 'reduce-logo-size';

    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    // Only relevant when sticky is enabled (this element exists only then)
    this.setHeaderHeight();

    window
    .matchMedia('(max-width: 990px)')
    .addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
    this.header.classList.add('shopify-section-header-sticky');
    }

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
    this.observeCountdownAndHeader(); // NEW
    }

    disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);

    if (this._ro) this._ro.disconnect();
    if (this._mo) this._mo.disconnect();
    }

    // Announcement bar is #countdown
    getCountdownOffset() {
    const el = document.getElementById('countdown');
    if (!el) return 0;

    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;

    const h = Math.round(el.offsetHeight || 0);
    return h > 0 ? h : 0;
    }

    setHeaderHeight() {
    if (!this.header) return;

    const countdownH = this.getCountdownOffset();

    // Expose variables for other components if needed
    document.documentElement.style.setProperty('--header-sticky-top', `${countdownH}px`);
    document.documentElement.style.setProperty(
    '--header-height',
    `${this.header.offsetHeight + countdownH}px`
    );

    // IMPORTANT: only apply top offset while sticky is actually used
    // (this class runs only when sticky-header element exists, but still safe)
    this.header.style.top = `${countdownH}px`;
    }

    observeCountdownAndHeader() {
    const countdown = document.getElementById('countdown');

    // ResizeObserver: reacts to countdown ticking height changes + header changes
    if ('ResizeObserver' in window) {
    this._ro = new ResizeObserver(() => this.setHeaderHeight());
    if (countdown) this._ro.observe(countdown);
    if (this.header) this._ro.observe(this.header);
    }

    // MutationObserver: reacts if countdown is injected/removed/hidden by apps
    this._mo = new MutationObserver(() => this.setHeaderHeight());
    this._mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'hidden'],
    });

    window.addEventListener('resize', this.setHeaderHeight.bind(this), { passive: true });
    window.addEventListener('orientationchange', this.setHeaderHeight.bind(this), { passive: true });
    window.addEventListener('load', this.setHeaderHeight.bind(this));
    }

    createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
    this.headerBounds = entries[0].intersectionRect;
    observer.disconnect();
    });

    observer.observe(this.header);
    }

    onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (this.preventHide) return;
    requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    this.header.classList.add('scrolled-past-header');
    if (!this.preventReveal) {
    requestAnimationFrame(this.reveal.bind(this));
    } else {
    window.clearTimeout(this.isScrolling);

    this.isScrolling = setTimeout(() => {
    this.preventReveal = false;
    }, 66);

    requestAnimationFrame(this.hide.bind(this));
    }
    } else if (scrollTop <= this.headerBounds.top) {
    this.header.classList.remove('scrolled-past-header');
    requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
    }

    hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
    }

    reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
    }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
